// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Thorchain Unchained API
 * Provides access to thorchain chain data.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AffiliateFee } from './AffiliateFee';
import {
    AffiliateFeeFromJSON,
    AffiliateFeeFromJSONTyped,
    AffiliateFeeToJSON,
} from './AffiliateFee';

/**
 * Contains info about affiliate fee history
 * @export
 * @interface AffiliateFees
 */
export interface AffiliateFees {
    /**
     * Affiliate fees
     * @type {Array<AffiliateFee>}
     * @memberof AffiliateFees
     */
    fees: Array<AffiliateFee>;
}

/**
 * Check if a given object implements the AffiliateFees interface.
 */
export function instanceOfAffiliateFees(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fees" in value;

    return isInstance;
}

export function AffiliateFeesFromJSON(json: any): AffiliateFees {
    return AffiliateFeesFromJSONTyped(json, false);
}

export function AffiliateFeesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliateFees {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fees': ((json['fees'] as Array<any>).map(AffiliateFeeFromJSON)),
    };
}

export function AffiliateFeesToJSON(value?: AffiliateFees | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fees': ((value.fees as Array<any>).map(AffiliateFeeToJSON)),
    };
}

